export default function Education() {
    return (
        <div>
            <div className="flex p-10 text-center">
            <span class="text-sky-700 text-4xl">EDUCATION</span>
                <div class="grid grid-cols-3 gap-4 translate-y-10 ">
                    <div>
                        <div class="col-span-2">
                            <p><span class= "font-bold">B.E in Computer Science and Engineering </span>| CGPA: 7 <br></br>
                            Government Engineering College Mosale Hosahalli, Hassan</p>
                        </div>
                        <div>
                            <p>Dec 2021-June 2025</p>
                        </div>
                    </div>
                    <div>
                        <div class="col-span-2">
                            <p><span class= "font-bold">XII (PCMB) 
                            </span>| Percentage: 96% <br></br>
                            Brigade PU College, Hassan</p>
                        </div>
                        <div>
                            <p>July 2021 </p>
                        </div>
                    </div>
                    <div>
                        <div class="col-span-2">
                            <p><span class= "font-bold">X (SSLC) 
                            </span>| Percentage: 88%  <br></br>
                            Brilliant Public School, Hassan</p>
                        </div>
                        <div>
                            <p>April-2019</p>
                        </div>
                    </div>
              </div>
            </div>
        </div>
    );
  }